/**
 * Normalizes a Finnish phone number to international format (+358...) with all spaces removed
 */
export function normalizePhone(phone: string | null | undefined): string | null {
    if (!phone) return null;

    // Remove all spaces
    let normalized = phone.replace(/\s+/g, '');

    // Handle case: starts with 0 (local Finnish number)
    if (normalized.startsWith('0')) {
        normalized = '+358' + normalized.substring(1);
    }
    // Already in international format (+358...)
    else if (normalized.startsWith('+')) {
        // Do nothing, already in plus format
    }
    // Assume no +, no leading 0, so it's just the number (like 45...)
    else {
        normalized = '+358' + normalized;
    }
    return normalized;
}

/**
 * Formats a phone number as "+358 45 346 2128" (Finnish standard)
 * If not enough digits, returns stripped version.
 */
export function formatPhoneReadable(phone: string | null | undefined): string {
    if (!phone) return '';

    // Always normalize first
    const digits = normalizePhone(phone);
    // Only match expected pattern: +cc... and numbers
    if (!digits) return '';

    // Remove "+" and split
    const result = digits.replace(/^\+/, '');
    // For Finland: +358 ######### (9 digits usually, but can be 10)
    // E.g. +358 45 346 2128 or +358 400 123 456
    // We'll take: +CCC XX XXX XXXX (3 + 2 + 3 + 4)
    // Split accordingly

    const re = /^(\d{3})(\d{2})(\d{3})(\d{4})$/; // e.g. 358453462128
    const reShort = /^(\d{3})(\d{1,3})(\d{3})(\d{3,4})$/; // handle short operator numbers

    let match = result.match(re);
    if (!match) {
        match = result.match(reShort);
    }

    if (match) {
        return `+${match[1]} ${match[2]} ${match[3]} ${match[4]}`;
    }

    // fallback: just return normalized with a space after country code, if possible
    if (result.length > 3) {
        return `+${result.slice(0, 3)} ${result.slice(3)}`;
    } else {
        return `+${result}`;
    }
}

